module.exports = {
    getUrl: () => 'getTokenInfo',

    getMethod: Odigeo._.constant('POST'),

    requestSuccess(data) {
        Odigeo.trigger(`${this.widget.id}:getTokenInfoOk`, data);
    },

    requestError() {
        Odigeo.trigger(`${this.widget.id}:getTokenInfoFail`);
    },
};
